/**
 * Effective access level — the single canonical abstraction over the raw Keycloak
 * realm roles (`internal`, `admin`, `basic`).
 *
 * Two orthogonal dimensions are combined into one effective level:
 *  - scope: `internal` (cross-client) vs external
 *  - tier:  `admin` vs basic (the floor every user has by default)
 *
 * The combination rules live in exactly one place — `resolveAccessLevel` (raw roles ->
 * access level) and `rolesForAccessLevel` (access level -> roles to grant) in
 * `utils/user-type.utils.ts`. A future move to dedicated internal-admin / internal-basic
 * roles edits only those two functions plus Keycloak config.
 */
export var AccessLevel;
(function (AccessLevel) {
    AccessLevel["EXTERNAL_BASIC"] = "external_basic";
    AccessLevel["EXTERNAL_ADMIN"] = "external_admin";
    AccessLevel["INTERNAL_BASIC"] = "internal_basic";
    AccessLevel["INTERNAL_ADMIN"] = "internal_admin";
})(AccessLevel || (AccessLevel = {}));
//# sourceMappingURL=access-level.enum.js.map